import React from 'react';
import ReactDOM from 'react-dom';
import App from './entree';
import Sortie from './sortie';
import Inventaire from './inventaire';
import { Router } from "@reach/router"

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <App path="/" />
      <Sortie path="/sortie" />
      <Inventaire path="/inventaire" />
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);